import { __extends } from "tslib";
import { AssetEvent, Matrix } from '@awayjs/core';
import { PartitionBase, EntityNode, HierarchicalProperty } from '@awayjs/view';
import { RendererBase } from '@awayjs/renderer';
import { Graphics } from '@awayjs/graphics';
import { DisplayObjectContainer } from './DisplayObjectContainer';
import { StageManager } from '@awayjs/stage';
import { SceneImage2D } from '../image/SceneImage2D';
import { Settings } from '../Settings';
/**
 * Sprite is an instance of a Graphics, augmenting it with a presence in the scene graph, a material, and an animation
 * state. It consists out of Graphices, which in turn correspond to SubGeometries. Graphices allow different parts
 * of the graphics to be assigned different materials.
 */
var Sprite = /** @class */ (function (_super) {
    __extends(Sprite, _super);
    /**
     * Create a new Sprite object.
     *
     * @param material    [optional]        The material with which to render the Sprite.
     */
    function Sprite(graphics, material) {
        if (graphics === void 0) { graphics = null; }
        if (material === void 0) { material = null; }
        var _this = _super.call(this) || this;
        _this._isEntity = false;
        _this._requestCacheAsBitmap = false;
        _this._cacheAsBitmap = false;
        _this._onGraphicsInvalidateDelegate = function (event) { return _this._onGraphicsInvalidate(event); };
        _this.graphics = graphics || Graphics.getGraphics();
        _this.material = material;
        _this.dropBitmapCache = _this.dropBitmapCache.bind(_this);
        _this.generateBitmapCache = _this.generateBitmapCache.bind(_this);
        return _this;
    }
    Sprite.getNewSprite = function (graphics, material) {
        if (graphics === void 0) { graphics = null; }
        if (material === void 0) { material = null; }
        if (Sprite._sprites.length) {
            var sprite = Sprite._sprites.pop();
            sprite.graphics = graphics || Graphics.getGraphics();
            sprite.material = material;
            return sprite;
        }
        return new Sprite(graphics, material);
    };
    Sprite.clearPool = function () {
        Sprite._sprites = [];
    };
    Object.defineProperty(Sprite.prototype, "assetType", {
        /**
         *
         */
        get: function () {
            return Sprite.assetType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Sprite.prototype, "graphics", {
        /**
         * Specifies the Graphics object belonging to this Sprite object, where
         * drawing commands can occur.
         */
        get: function () {
            if (this._iSourcePrefab)
                this._iSourcePrefab._iValidate();
            if (this.isSlice9ScaledSprite) {
                //var comps:Array<Vector3D> = this.transform.concatenatedMatrix3D.decompose();
                this._graphics.updateSlice9(this.parent.scaleX, this.parent.scaleY);
            }
            return this._graphics;
        },
        set: function (value) {
            if (value == null)
                throw new Error('Cannot have graphics set to null');
            this._setGraphics(value);
        },
        enumerable: true,
        configurable: true
    });
    Sprite.prototype._setGraphics = function (value) {
        if (this._graphics == value) {
            return;
        }
        if (this._graphics) {
            this._graphics.removeEventListener(AssetEvent.INVALIDATE, this._onGraphicsInvalidateDelegate);
            this._graphics.usages--;
            //if (!this._graphics.usages)
            //	this.graphics.dispose();
        }
        this._graphics = value;
        this._graphics.usages++;
        this._onGraphicsInvalidate(null);
    };
    Sprite.prototype._setParent = function (parent) {
        _super.prototype._setParent.call(this, parent);
        if (parent)
            this._graphics.addEventListener(AssetEvent.INVALIDATE, this._onGraphicsInvalidateDelegate);
        else
            this._graphics.removeEventListener(AssetEvent.INVALIDATE, this._onGraphicsInvalidateDelegate);
        if (this._requestCacheAsBitmap) {
            this.set_cacheAsBitmapInternal(true);
            console.log('Restore cache');
        }
    };
    Sprite.prototype.isEntity = function () {
        return ((this._graphics && this._graphics.count > 0)
            || (this._bitmapCacheGraphics && this._bitmapCacheGraphics.count > 0));
    };
    Sprite.prototype.set_scale9gridInternal = function (rect) {
        //this._scale9Grid = rect;
        if (!Settings.USE_UNSAFE_SCALE_9_SLICE) {
            return;
        }
        console.warn('[Sprite] You use unsafe feature `scale9slice` it force `cacheAsBitmap` for this node' +
            'disable it for supress bugs', 'Settings.USE_UNSAFE_SCALE_9_SLICE', this.id);
        _super.prototype.set_scale9gridInternal.call(this, rect);
        this.set_cacheAsBitmapInternal(!!rect);
    };
    Sprite.prototype.get_cacheAsBitmapInternal = function () {
        if (!Settings.USE_UNSAFE_CACHE_AS_BITMAP) {
            return false;
        }
        return this._requestCacheAsBitmap;
    };
    Sprite.prototype.set_cacheAsBitmapInternal = function (value) {
        if (!Settings.USE_UNSAFE_CACHE_AS_BITMAP && !this.scale9Grid) {
            return;
        }
        if (this._cacheAsBitmap === value)
            return;
        console.warn('[Sprite] You use unsafe feature `cacheAsBitmap`, disable it for supress bugs', 'Settings.USE_UNSAFE_CACHE_AS_BITMAP', this.id);
        // we set flag, because a propery can be spammed to many times in one frame
        this._requestCacheAsBitmap = value;
        if (!this.parent && value) {
            console.warn('[Sprite] There are not parent, supress cache');
            return;
        }
        var run = Settings.IMMEDIATE_CACHE_AS_BITMAP;
        // drop cache, or it will droped in next traverser pass
        if (!value) {
            this.dropBitmapCache();
        }
        // we can't render in traverser pass until a render process
        // we can doing this is immediate
        // or at end of frame
        if (value) {
            if (run) {
                this.generateBitmapCache();
            }
            else {
                StageManager
                    .getInstance()
                    .getStageAt(0)
                    .requiestFrameEnd(this.generateBitmapCache);
            }
        }
    };
    Sprite.prototype.dropBitmapCache = function () {
        if (this._requestCacheAsBitmap === this._cacheAsBitmap) {
            return;
        }
        this._bitmapCacheShape && this._bitmapCacheShape.dispose();
        this._bitmapCacheImage && this._bitmapCacheImage.dispose();
        this._bitmapCacheGraphics && this._bitmapCacheGraphics.dispose();
        this._cacheAsBitmap = false;
        this._bitmapCacheImage = null;
        this._bitmapCacheGraphics = null;
        this._bitmapCacheShape = null;
        this._requestCacheAsBitmap = false;
        this._invalidateHierarchicalProperty(HierarchicalProperty.CACHE_AS_BITMAP);
    };
    Sprite.prototype.generateBitmapCache = function () {
        if (this._requestCacheAsBitmap === this._cacheAsBitmap) {
            return;
        }
        if (this._cacheAsBitmap) {
            return;
        }
        var stage = StageManager.getInstance().getStageAt(0);
        // unsafe, but there are not other way =(
        var rect = this.adapter.getBoundsInternal(null);
        // remove flag to allow render real scene tree in cache
        this._cacheAsBitmap = false;
        this._requestCacheAsBitmap = false;
        var scale9grid = this.get_scale9gridInternal();
        var PADDING = this.scale9Grid ? 2 : 4;
        var width = rect.width + PADDING;
        var height = rect.height + PADDING;
        var x = rect.x - PADDING / 2;
        var y = rect.y - PADDING / 2;
        rect.x = x | 0;
        rect.y = y | 0;
        rect.width = width | 0;
        rect.height = height | 0;
        if (!this._bitmapCacheGraphics) {
            this._bitmapCacheGraphics = Graphics.getGraphics();
        }
        var graphics = this._bitmapCacheGraphics;
        if (!this._bitmapCacheImage ||
            this._bitmapCacheImage.width !== width ||
            this._bitmapCacheImage.height !== height) {
            if (this._bitmapCacheImage) {
                this._bitmapCacheImage.dispose();
            }
            if (this._bitmapCacheShape) {
                this._bitmapCacheShape.dispose();
                this._bitmapCacheShape = null;
            }
            this._bitmapCacheImage = SceneImage2D.getImage(width, height, true, 0, false, stage, false);
        }
        var m = new Matrix(1, 0, 0, 1, -x, -y);
        this._bitmapCacheImage.draw(this, m);
        m.rawData[4] = x;
        m.rawData[5] = y;
        if (!this._bitmapCacheShape) {
            this._bitmapCacheShape = Graphics.getShapeForBitmap(this._bitmapCacheImage, rect, !!scale9grid);
            graphics.addShape(this._bitmapCacheShape);
        }
        if (scale9grid) {
            var slice = this._bitmapCacheShape;
            slice.slice = this.scale9Grid;
            slice.scaleX = this.scaleX;
            slice.scaleY = this.scaleY;
        }
        this._cacheAsBitmap = this._requestCacheAsBitmap = true;
        this._invalidateHierarchicalProperty(HierarchicalProperty.CACHE_AS_BITMAP);
    };
    /**
     * @inheritDoc
     */
    Sprite.prototype.dispose = function () {
        this.disposeValues();
        Sprite._sprites.push(this);
    };
    /**
     * @inheritDoc
     */
    Sprite.prototype.disposeValues = function () {
        _super.prototype.disposeValues.call(this);
    };
    /**
     * Clones this Sprite instance along with all it's children, while re-using the same
     * material, graphics and animation set. The returned result will be a copy of this sprite,
     * containing copies of all of it's children.
     *
     * Properties that are re-used (i.e. not cloned) by the new copy include name,
     * graphics, and material. Properties that are cloned or created anew for the copy
     * include subSpritees, children of the sprite, and the animator.
     *
     * If you want to copy just the sprite, reusing it's graphics and material while not
     * cloning it's children, the simplest way is to create a new sprite manually:
     *
     * <code>
     * var clone : Sprite = new Sprite(original.graphics, original.material);
     * </code>
     */
    Sprite.prototype.clone = function () {
        var newInstance = Sprite.getNewSprite();
        this.copyTo(newInstance);
        return newInstance;
    };
    Sprite.prototype.copyTo = function (sprite, cloneShapes) {
        if (cloneShapes === void 0) { cloneShapes = false; }
        _super.prototype.copyTo.call(this, sprite);
        sprite._iSourcePrefab = this._iSourcePrefab;
        this._graphics.copyTo(sprite._graphics, cloneShapes);
    };
    /**
     *
     */
    Sprite.prototype._iInternalUpdate = function () {
        _super.prototype._iInternalUpdate.call(this);
        // if(this.parent)
        // 	this._graphics.updateScale(view);
    };
    /**
     * //TODO
     *
     * @private
     */
    Sprite.prototype._onGraphicsInvalidate = function (event) {
        var isEntity = this.isEntity();
        if (this._isEntity != isEntity) {
            if (!isEntity)
                this._clearEntity();
            this._isEntity = isEntity;
        }
        this.invalidate();
    };
    /**
     *
     * @param renderer
     *
     * @internal
     */
    Sprite.prototype._acceptTraverser = function (traverser) {
        var isRenderPhase = traverser instanceof RendererBase;
        // render it if cached
        if (this._cacheAsBitmap && isRenderPhase && this._cacheAsBitmap === this._requestCacheAsBitmap) {
            this._bitmapCacheGraphics._acceptTraverser(traverser);
            return;
        }
        // default phase, when cache is not exist
        _super.prototype._acceptTraverser.call(this, traverser);
        this.graphics._acceptTraverser(traverser);
    };
    /**
     *
     */
    Sprite.prototype.bakeTransformations = function () {
        this._graphics.applyTransformation(this.transform.matrix3D);
        this.transform.clearMatrix3D();
    };
    Sprite._sprites = new Array();
    Sprite.assetType = '[asset Sprite]';
    return Sprite;
}(DisplayObjectContainer));
export { Sprite };
PartitionBase.registerAbstraction(EntityNode, Sprite);
